<template>
  <keep-alive>
      <device-list />
  </keep-alive>
</template>
<script>
import DeviceList from './DeviceList/DeviceList.vue'
export default {
  components: {
    DeviceList
  }
}
</script>
